import { createState } from '~/util/storeHelpers'
import PromotionMapper  from '@/components/shared/Cards/CardPromotionPreview/mapper.js'
const onlineBanners = createState({ key: 'onlineBanners', initialValue: [] })
const mainPageBanners = createState({ key: 'mainPageBanners', initialValue: [] })
const banner = createState({ key: 'banner', initialValue: {} })
export const state = () => ({
  onlineBanners: onlineBanners.state,
  mainPageBanners: mainPageBanners.state,
  banner: banner.state,
})

export const mutations = {
  set_onlineBanners: onlineBanners.setter,
  set_mainPageBanners: mainPageBanners.setter,
  set_banner: banner.setter,
}

export const actions = {
  async fetch_banners({ commit }, type) {
    try {
      commit('set_onlineBanners', { isLoading: true })
      commit('set_mainPageBanners', { isLoading: true })
      const { data } = await this.$api.billboard.getBanners({ type })
      const mapData = data.banners.map(PromotionMapper.fromWidgetToCard)

      switch (type) {
      case 'online':
        commit('set_onlineBanners', { data: mapData })
        break
      case 'main_page':
        commit('set_mainPageBanners', { data: mapData })
        break
      }
    }
    catch (err) {
      commit('set_onlineBanners', { error: err })
      commit('set_mainPageBanners', { error: err })
    }
    finally {
      commit('set_onlineBanners', { isLoading: false })
      commit('set_mainPageBanners', { isLoading: false })
    }
  },

  async fetch_banner({ commit },  term ) {
    try {
      commit('set_banner', { isLoading: true })
      const { data: { banner: action } } = await this.$api.billboard.getBannerBillboard({ term })
      commit('set_banner', { data: action })
    }
    catch (err) {
      commit('set_banner', { error: err })
    }
    finally {
      commit('set_banner', { isLoading: false })
    }
  },
  reset_banner ({ commit }) {
    commit('set_banner', { reset: true })
  },
}

export const getters = {
  get_onlineBanners: onlineBanners.getter,
  get_mainPageBanners: mainPageBanners.getter,
  get_banner: banner.getter,
}
